import { Row } from "@components/Flex";
import { RadioButton } from "@components/RadioButton";
import { Body } from "@components/Typography";
import { useTheme } from "@hooks";
import { styles } from "./styles";
import { ResidentSelectionProps } from "./types";

export const ResidentSelection = ({ label, value, onClick, disabled }: ResidentSelectionProps) => {
  const { theme } = useTheme();

  return (
    <div onClick={disabled ? undefined : onClick} style={styles.container}>
      <Row style={styles.row}>
        <RadioButton
          value={value}
          disabled={disabled}
          style={styles.radio}
          unfilledColor={theme.radio.unfilled}
        />
        <Body style={styles.label}>{label}</Body>
      </Row>
    </div>
  );
};
